import { render, staticRenderFns } from "./EmployeeItem.vue?vue&type=template&id=b3a3078a&scoped=true"
import script from "./EmployeeItem.vue?vue&type=script&lang=js"
export * from "./EmployeeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a3078a",
  null
  
)

export default component.exports